import React from 'react';
import { LightgalleryProvider } from 'react-lightgallery';
import OpenButtonWithHook from './OpenButtonWithHook';
import ImageItem from './ImageItem';
import './LightBox.css';

const LightBox = ({ images, currentIndex }) => (
  <div className="content">
    <LightgalleryProvider>
      <div
        style={{
          display: 'none'
        }}
      >
        {images.map(i => (
          <ImageItem
            key={`${i.title}_${i.alt}_${i.src}`}
            image={i.src}
            thumb={i.src}
            alt={i.alt}
            group="group1"
          />
        ))}
      </div>
      <div className="buttons mt-4">
        <OpenButtonWithHook
          image={images[currentIndex]}
          currentIndex={currentIndex}
        />
      </div>
    </LightgalleryProvider>
  </div>
);

export default LightBox;
